/**
 * A rule a field's value must meet beyond what the browser checks, given the whole
 * record so it can depend on another field. Returns the message to show, or "" when the
 * value is fine.
 */
export type FieldValidator = (
  value: unknown,
  record: Record<string, unknown>
) => string;

/** Validators a field can name, addressed by key so page config stays serialisable. */
export const fieldValidators: Record<string, FieldValidator> = {};

/** Filled from each record definition's own validators, by recordDefinitions. */
export function registerFieldValidators(
  validators: Record<string, FieldValidator> | undefined
) {
  Object.assign(fieldValidators, validators);
}

/** Undefined for an unknown name, so an older build still saves the page. */
export function getFieldValidator(name: string | undefined) {
  return name ? fieldValidators[name] : undefined;
}
